import React from "react";

/**
 * FlowerOfLife — decorative SVG of the classic 19-circle sacred geometry.
 * Props:
 *   color: stroke color
 *   opacity: stroke opacity (0..1)
 *   className: extra classes (e.g. positioning, animation)
 *   strokeWidth: stroke width in SVG units
 *   size: css size (e.g. "600px"); default fills container via w-full/h-full
 */
const FlowerOfLife = ({
    color = "#d4af37",
    opacity = 0.35,
    className = "",
    strokeWidth = 0.6,
}) => {
    const R = 60; // circle radius
    const sqrt3 = Math.sqrt(3);
    const h = (sqrt3 / 2) * R;

    // 19 circles (classic Flower of Life in hex grid)
    const centers = [
        // Row y = -sqrt3*R
        [-R, -sqrt3 * R],
        [0, -sqrt3 * R],
        [R, -sqrt3 * R],
        // Row y = -h
        [-1.5 * R, -h],
        [-0.5 * R, -h],
        [0.5 * R, -h],
        [1.5 * R, -h],
        // Row y = 0
        [-2 * R, 0],
        [-R, 0],
        [0, 0],
        [R, 0],
        [2 * R, 0],
        // Row y = h
        [-1.5 * R, h],
        [-0.5 * R, h],
        [0.5 * R, h],
        [1.5 * R, h],
        // Row y = sqrt3*R
        [-R, sqrt3 * R],
        [0, sqrt3 * R],
        [R, sqrt3 * R],
    ];

    return (
        <svg
            viewBox="-220 -220 440 440"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-hidden="true"
        >
            {/* Outer containing circle */}
            <circle
                cx="0"
                cy="0"
                r={2 * R}
                fill="none"
                stroke={color}
                strokeOpacity={opacity * 0.9}
                strokeWidth={strokeWidth * 1.5}
            />
            {centers.map(([cx, cy], i) => (
                <circle
                    key={i}
                    cx={cx}
                    cy={cy}
                    r={R}
                    fill="none"
                    stroke={color}
                    strokeOpacity={opacity}
                    strokeWidth={strokeWidth}
                />
            ))}
        </svg>
    );
};

export default FlowerOfLife;
